import { Provider } from '@angular/core';

import { factoryManageVacationsUseCasesProvider } from '@app/di/use-cases/providers/factory-manage-vacations.use-cases.provider';
import { momoManageVacationsUseCasesProvider } from '@app/di/use-cases/providers/momo-manage-vacations.use-cases.provider';

import { contentTranslateUseCasesProvider } from './content-translate/content-translate.use-cases.provider';
import { firebaseAnalyticsUseCasesProvider } from './firebase-analytics.use-cases.provider';
import { irsUseCasesProvider } from './irs/irs.use-cases.provider';
import { clockingUseCasesProvider } from './mot/clocking.use-cases.provider';
import { scheduleUseCasesProvider } from './mot/schedule.use-cases.provider';
import { signedTimetablesUseCasesProvider } from './mot/signed-timetables.use-cases.provider';
import { vacationsUseCasesProvider } from './mot/vacations.use-cases.provider';
import { networkUseCasesProvider } from './network/network.use-cases.provider';
import { notificationUseCasesProvider } from './notification/notification.use-cases.provider';
import { personalDataUseCasesProvider } from './personal-data/personal-data.use-cases.provider';
import { auditUseCasesProvider } from './providers/audit.use-cases.provider';
import { codesUseCasesProvider } from './providers/codes.use-cases.provider';
import { commentUseCasesProvider } from './providers/comment.use-cases.provider';
import { evaluationUseCasesProvider } from './providers/evaluation.use-cases.provider';
import { geographyUseCasesProvider } from './providers/geography.use-cases.provider';
import { logisticsManageVacationsUseCasesProvider } from './providers/logistics-manage-vacations.use-cases.provider';
import { motManageVacationsUseCasesProvider } from './providers/mot-manage-vacations.use-cases.provider';
import { onBoardingVideoUseCasesProvider } from './providers/on-boarding-video.use-cases.provider';
import { publicationUseCasesProvider } from './providers/publication.use-cases.provider';
import { staticTextUseCasesProvider } from './providers/static-text.use-cases.provider';
import { videoUseCasesProvider } from './providers/video.use-cases.provider';
import { certificatesUseCasesProvider } from './ptrab/certificates/certificates.use-cases.provider';
import { documentsUseCasesProvider } from './ptrab/documents/documents.use-cases.provider';
import { irpfUseCasesProvider } from './ptrab/irpf/irpf.use-cases.provider';
import { irpfReadjustmentUseCasesProvider } from './ptrab/irpf-readjustment/irpf-readjustment.use-cases.provider';
import { licensePlatesUseCasesProvider } from './ptrab/license-plates/license-plates.use-cases.provider';
import { payslipsUseCasesProvider } from './ptrab/payslips/payslips.use-cases.provider';
import { pdfUseCasesProvider } from './ptrab/pdf/pdf.use-cases.provider';
import { ptrabSessionUseCasesProvider } from './ptrab/session/session.use-cases.provider';
import { twoFactorUseCasesProvider } from './ptrab/two-factor/two-factor.use-cases.provider';
import { withholdingUseCasesProvider } from './ptrab/withholding/withholding.use-cases.provider';
import { searchUseCasesProvider } from './search/search.use-cases.provider';
import { tourUseCasesProvider } from './tour.use-cases.provider';
import { userUseCasesProvider } from './user/user.use-cases.provider';

export const getUseCasesProviders: () => Provider[] = () => [
  auditUseCasesProvider,
  commentUseCasesProvider,
  videoUseCasesProvider,
  publicationUseCasesProvider,
  geographyUseCasesProvider,
  onBoardingVideoUseCasesProvider,
  staticTextUseCasesProvider,
  contentTranslateUseCasesProvider,
  irsUseCasesProvider,
  scheduleUseCasesProvider,
  signedTimetablesUseCasesProvider,
  vacationsUseCasesProvider,
  networkUseCasesProvider,
  notificationUseCasesProvider,
  personalDataUseCasesProvider,
  certificatesUseCasesProvider,
  licensePlatesUseCasesProvider,
  documentsUseCasesProvider,
  irpfUseCasesProvider,
  irpfReadjustmentUseCasesProvider,
  payslipsUseCasesProvider,
  pdfUseCasesProvider,
  ptrabSessionUseCasesProvider,
  twoFactorUseCasesProvider,
  withholdingUseCasesProvider,
  searchUseCasesProvider,
  userUseCasesProvider,
  clockingUseCasesProvider,
  firebaseAnalyticsUseCasesProvider,
  tourUseCasesProvider,
  motManageVacationsUseCasesProvider,
  factoryManageVacationsUseCasesProvider,
  logisticsManageVacationsUseCasesProvider,
  momoManageVacationsUseCasesProvider,
  evaluationUseCasesProvider,
  codesUseCasesProvider
];
